import { render, staticRenderFns } from "./bstrategy.vue?vue&type=template&id=18db8339&scoped=true&"
import script from "./bstrategy.vue?vue&type=script&lang=js&"
export * from "./bstrategy.vue?vue&type=script&lang=js&"
import style0 from "./bstrategy.vue?vue&type=style&index=0&id=18db8339&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18db8339",
  null
  
)

export default component.exports